<template>

  <div class="home">

    <appdrawer :drawer="drawer"></appdrawer>

    <appnavbar :title="$route.name" @toggle="drawer = !drawer"></appnavbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-snackbar top v-model="$store.state.isError" color="dark" :timeout="2000" dark> 
        {{ $store.state.isError }}!
    </v-snackbar>

  </div>

</template>

<script>
import appdrawer from '../components/drawer'
import appnavbar from '../components/navbar'

export default {
  name: 'Home',
  components: {
    appdrawer,
    appnavbar
  },
  data: () => ({
    drawer: true,
    navbarTitle: 'Dashboard'
  })
}
</script>

<style>
.v-data-table-header {
    background-color: #546E7A;
}
th > span, th > i { color: white !important; }
tr:nth-child(even) {
    background-color: #f7f7f7;
}
</style>
